// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-message-template-back-button{width:100%;max-width:405px;margin:auto}.c-message-template-back-button--hidden{visibility:hidden}.c-message-template-back-button__button{padding:8px;margin-bottom:16px;min-width:90px;height:44px;display:flex;align-items:center;justify-content:space-between;color:var(--primary--hover)}.c-message-template-back-button svg{height:16px;margin:0;margin-right:8px}.c-message-template-back-button svg path{fill:var(--primary--hover)}", ""]);
// Exports
module.exports = exports;
